/* unplugin-vue-components disabled */import { useCssVars as _useCssVars } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue";
export default {
  __name: 'index',
  props: {
    size: {
      type: String,
      default: "default"
      // default 为三种大小
      // min
      // max
    },
    time: {
      type: Number,
      default: 1
    },
    debounce: {
      type: Boolean,
      default: true
    },
    plain: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  setup(__props, {
    emit: __emit
  }) {
    _useCssVars(_ctx => ({
      "7494d239": _unref(sizes),
      "02839b18": _unref(animationTime)
    }));
    const props = __props;
    const emits = __emit;
    const spanList = ref([]);
    const rippleState = ref(false);
    const {
      size,
      time,
      debounce
    } = toRefs(props);
    const ripple = ref(null);
    const ButtonClick = evn => {
      const {
        layerX,
        layerY
      } = evn;
      if (!debounce.value) {
        spanList.value.push({
          x: layerX + "px",
          y: layerY + "px",
          isState: true
        });
        emits("click");
        return;
      }
      if (rippleState.value) return;
      rippleState.value = true;
      nextTick(() => {
        ripple.value != null && (ripple.value.style.left = layerX + "px");
        ripple.value != null && (ripple.value.style.top = layerY + "px");
        setTimeout(() => {
          rippleState.value = false;
        }, time.value * 1000);
      });
      emits("click");
    };

    //此处为按钮大小
    const sizes = computed(() => {
      return {
        default: "0.55rem",
        min: "0.4rem",
        max: "0.7rem"
      }[size.value];
    });
    const animationTime = computed(() => {
      return time.value + "s";
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("button", {
        class: "corrugationButton_css",
        onClick: _withModifiers(ButtonClick, ["stop"]),
        style: _normalizeStyle({
          '--scale': {
            default: 5,
            min: 4,
            max: 6
          }[_unref(size)],
          '--span-color': '#fff',
          '--btn-bgc': __props.plain ? '#fff' : '#409eff',
          '--btn-color': __props.plain ? '#000000' : '#fff',
          '--btn-border': __props.plain ? '#ccc' : '#fff',
          '--btn-show': __props.plain ? '#409EFF' : '#fff'
        })
      }, [_renderSlot(_ctx.$slots, "default"), _unref(debounce) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(rippleState) ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "corrugationButton_css_span ripple_animation",
        ref_key: "ripple",
        ref: ripple
      }, null, 512)) : _createCommentVNode("", true)], 64)) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(_unref(spanList), (v, i) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [v.isState ? (_openBlock(), _createElementBlock("span", {
          key: i,
          class: "corrugationButton_css_span ripple_animation",
          style: _normalizeStyle({
            top: v.y,
            left: v.x
          })
        }, null, 4)) : _createCommentVNode("", true)], 64);
      }), 256))], 4);
    };
  }
};